import {OEAsset, useClient, useDictionary} from '@adamlip/okeoke.client'
import {Button, Checkbox, Textarea} from '@heroui/react'
import {Element} from 'react-scroll'
import BarSoftButton from 'components/_NewComponents/BarSoftButton'
import UpsaleItem from 'components/_OrderElements/UpsaleItem'
import Icon from 'assets/icons'
import NumberFlow from '@number-flow/react'
import {Check, Minus, Plus, ShoppingCart} from 'lucide-react'
import {AnimatePresence, motion} from 'framer-motion'
import {AppParamsContext} from 'contexts/AppParamsContext'
import {useContext, useEffect, useRef, useState} from 'react'
import ModifierGroupSelector from 'components/Modals/OrderItemModalV3/ModifierGroupSelector'
import SizeSelector from 'components/Modals/OrderItemModalV3/SizeSelector'
import {MainContext} from 'contexts/MainContext'

function ImageFocusedLayout({assembledItem, menuItemParams, sizeUUID, readOnly, upsaleItems, couponItem, setModifierCount, setTakeAway, setSize, tryedToAdd, itemNotes, handleChangeNotes, handleBlurNotes, handleAddToCart, buttonText, changeCount, isAdded, handleItemSelect}) {
	const {getValue} = useDictionary()
	const {getName} = useClient()
	const {appParams} = useContext(AppParamsContext)
	const {noSafeAreaInTheApp} = useContext(MainContext)
	const [isFocused, setIsFocused] = useState(false)
	const imgWrapperClass = `order-1 justify-end items-start flex-grow-0 flex-shrink-0 w-[280px] flex mr-6 relative `
	const scrollRef = useRef(null)
	const textareaRef = useRef(null)

	const haveModifierGroups =
		assembledItem.modifierGroups
			?.filter((group) => group?.availability?.visible === 1)
			.sort((a, b) => (a?.min > b?.min ? 1 : -1))
			.sort((a, b) => (a?.idx > b?.idx ? 1 : -1))?.length > 0
	useEffect(() => {
		const textarea = textareaRef.current

		function handleFocus() {
			setTimeout(() => {
				textarea.scrollIntoView({behavior: 'smooth', block: 'end'})
			}, 400)
		}

		if (textarea) {
			textarea.addEventListener('focus', handleFocus)
		}

		return () => {
			if (textarea) {
				textarea.removeEventListener('focus', handleFocus)
			}
		}
	}, [])
	return (
		<>
			<div className='w-full  grow flex flex-col gap-0 items-start justify-start overflow-x-hidden  overflow-y-scroll !relative pb-2' ref={scrollRef} style={{}}>
				{!isFocused && (
					<div className='z-50 sticky top-0 pt-4 bg-background'>
						<div className='px-4 pt-6 pb-4 flex flex-row gap-1 bg-background items-center !relative z-50 pl-6'>
							<div id='desc' className={`font-black text-4xl `}>
								{getName(assembledItem.name)}
							</div>
						</div>
					</div>
				)}

				{(!isFocused && haveModifierGroups) || (getName(assembledItem.description) || '') !== '' ? (
					<>
						<div className={`py-5  items-center  flex min-h-[300px] ${haveModifierGroups ? '-ml-28' : ''}  `}>
							<div className={`ease-in duration-300 transition-colors p-5 rounded-2xl justify-between flex flex-row  min-h-[220px] ${haveModifierGroups ? 'grow' : 'mx-auto'} `}>
								<OEAsset uuid={assembledItem?.attributes.appImage} addContainerClass={imgWrapperClass} addClass={`absolute top-1/2 -translate-y-1/2 `} size='l' />

								{(haveModifierGroups || (getName(assembledItem.description) || '') !== '') && (
									<>
										<div className={`order-2 flex flex-col items-start justify-center flex-grow gap-y-[0px]  `}>
											<div className='font-black text-3xl'>
												{getName(
													assembledItem.modifierGroups
														?.filter((group) => group?.availability?.visible === 1)
														?.sort((a, b) => (a?.min > b?.min ? 1 : -1))
														?.sort((a, b) => (a?.idx > b?.idx ? 1 : -1))?.[0]?.name
												)}
											</div>

											<div className='text-xs opacity-70'>{getName(assembledItem.description)}</div>
										</div>
									</>
								)}
							</div>
						</div>
					</>
				) : (
					<OEAsset uuid={assembledItem?.attributes.appImage} addContainerClass={'w-full flex justify-center items-center'} addClass={`w-[250px] h-full object-cover`} size='l' />
				)}

				{!isFocused && menuItemParams == null && assembledItem?.depositPrice > 0 && (
					<div className='w-full text-left px-4 text-sm opacity-70 italic'>
						{getValue('app_v2_item_deposit')}
						{' ('}
						{assembledItem?.depositPrice}
						{' Ft)'}
					</div>
				)}

				{!isFocused && menuItemParams == null && sizeUUID == null && assembledItem?.sizes?.filter((size) => !size?.attributes?.menuSize).length > 1 && (
					<div className=' z-10 px-2'>
						<SizeSelector sizes={assembledItem.sizes?.filter((size) => !size?.attributes?.menuSize)} setSize={setSize} selectedSizeUUID={assembledItem.selectedSizeUUID} />
					</div>
				)}
				<div className='px-2 flex flex-col gap-2 w-full z-0 !relative  '>
					{!isFocused &&
						assembledItem.modifierGroups
							?.filter((group) => group?.availability?.visible === 1)
							.sort((a, b) => (a?.min > b?.min ? 1 : -1))
							.sort((a, b) => (a?.idx > b?.idx ? 1 : -1))
							.map((group, index) => {
								return (
									<Element key={group.uuid} name={group.uuid} className='px-4'>
										<ModifierGroupSelector key={group.uuid} firstInvalid={null} group={group} setModifierCount={setModifierCount} readOnly={readOnly} tryedToAdd={tryedToAdd} name={group?.uuid} />
									</Element>
								)
							})}
					{!isFocused && !readOnly && !(appParams?.items?.takeAwayHidden === true) && (
						<div className='my-2 w-full'>
							<Checkbox isSelected={assembledItem.takeAway} onValueChange={() => setTakeAway(assembledItem.takeAway ? 0 : 1)}>
								<div className='flex flex-row gap-2 items-center'>
									<div className='w-6 h-6'>
										<Icon name='takeAway' className='fill-current' />
									</div>
									{getValue('app_v2_orderItem_takeAway')}
								</div>
							</Checkbox>
						</div>
					)}

					{!readOnly && !(appParams?.items?.notesHidden === true) && (
						<div className='orderItemModifierGroup-modifier-root orderItem-modal-notes font-small px-4 pt-4'>
							<Textarea
								ref={textareaRef}
								aria-label='input'
								type='text'
								className='italic'
								id='itemNotes'
								classNames={{
									inputWrapper: 'bg-inputBackground text-inputText !h-24 border-2 border-inputBorder font-bold',
									input: 'text-inputBorder !font-bold',
									label: `${appParams?.styles?.fonts?.capitalize ? 'font-bold uppercase' : ''} group-data-[filled-within=true]:text-inputText text-inputText group-data-[filled-within=true]:text-[12px]`,
								}}
								name='itemNotes'
								label={`${getValue('app_v2_orderItem_notes')}...`}
								value={itemNotes}
								fullWidth={true}
								onChange={handleChangeNotes}
								onBlur={handleBlurNotes}
								onFocusChange={(isFocused) => {
									setIsFocused(false)
								}}
							/>
						</div>
					)}
					{!readOnly && upsaleItems != null && upsaleItems.length > 0 && (
						<>
							<div className='text-center mb-05 mt-2 font-bold'>{getValue('app_v2_upsellTitle')}</div>
							<div className='upsell-items-container'>
								{upsaleItems.map((item, index) => (
									<UpsaleItem key={index} itemUUID={item.itemUUID} />
								))}
							</div>
						</>
					)}
				</div>
			</div>

			<div className='w-full shrink-0 flex flex-row pt-2 items-center justify-between pb-4  overflow-hidden gap-2 z-10 px-6'>
				{couponItem == null && menuItemParams?.hideCounter == null && !readOnly && (
					<div className='flex flex-row gap-2 w-auto items-center  p-[0.2rem] bg-background border-1 border-border rounded-full'>
						<Button
							size={appParams?.buttons?.['addToBasket']?.size === 'md' ? 'sm' : appParams?.buttons?.['addToBasket']?.size === 'lg' ? 'md' : 'sm'}
							color='primary'
							className='bg-transparent text-foreground'
							radius='full'
							variant='solid'
							isDisabled={assembledItem?.count < 2}
							isIconOnly
							onPress={() => changeCount(assembledItem?.count - 1)}>
							<Minus className='w-4 h-4' />
						</Button>
						<div className='min-w-[30px] flex items-center justify-center'>
							<NumberFlow value={+assembledItem?.count || 0} />
						</div>
						<Button
							className='bg-transparent text-foreground'
							size={appParams?.buttons?.['addToBasket']?.size === 'md' ? 'sm' : appParams?.buttons?.['addToBasket']?.size === 'lg' ? 'md' : 'sm'}
							radius='full'
							color='primary'
							variant='solid'
							isIconOnly
							onPress={() => changeCount(assembledItem?.count + 1)}>
							<Plus className='w-4 h-4' />
						</Button>
					</div>
				)}
				{couponItem == null && (
					<div className={` ${appParams?.buttons?.['addToBasket']?.containerClass || 'grow overflow-hidden'} font-bold `}>
						<AnimatePresence>
							<BarSoftButton onPress={handleAddToCart} forceHideStartIcon forceCustom={isAdded} color={isAdded ? 'primary' : 'primary'} buttonName='addToBasket' fullWidth isDisabled={assembledItem?.valid ? false : true} size='lg' className=' px-3 justify-start'>
								<AnimatePresence mode='wait'>
									<motion.div key={isAdded ? 'check' : 'cart'} initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} exit={{opacity: 0, y: -20}} transition={{duration: 0.2}} className='flex items-center w-full gap-2'>
										{isAdded ? (
											<>
												<motion.div
													initial={{scale: 0}}
													animate={{scale: 1}}
													transition={{
														type: 'spring',
														stiffness: 500,
														damping: 15,
														delay: 0.1,
													}}>
													<Check className='w-5 h-5' />
												</motion.div>
												<span>{getValue('app_v2_item_added')}</span>
											</>
										) : (
											<>
												<motion.div
													animate={{rotate: [0, 10, -10, 0]}}
													transition={{
														duration: 0.5,
														ease: 'easeInOut',
														times: [0, 0.2, 0.8, 1],
														repeat: 0,
														repeatDelay: 1,
													}}>
													<ShoppingCart className='w-5 h-5' />
												</motion.div>
												<div className={`w-full flex flex-row gap-2 items-center justify-between overflow-hidden`}>
													<span className='font-semibold'>{buttonText}</span>
													{menuItemParams == null && (
														<span className='min-w-[30px] flex items-center justify-center font-bold'>
															<NumberFlow value={+assembledItem?.totalPrice || 0} suffix=' Ft' />
														</span>
													)}
												</div>
											</>
										)}
									</motion.div>
								</AnimatePresence>

								{isAdded && <motion.div initial={{scale: 0, opacity: 1}} animate={{scale: 2, opacity: 0}} transition={{duration: 0.7}} className='absolute w-full h-full bg-white rounded-full' />}
							</BarSoftButton>
						</AnimatePresence>
					</div>
				)}
				{couponItem != null && (
					<div className={` ${appParams?.buttons?.['addToBasket']?.containerClass || ''} `}>
						<BarSoftButton buttonName='addToBasket' color='primary' onPress={() => handleItemSelect(assembledItem)}>
							{getValue('app_v2_items_coupon_item_select')}
						</BarSoftButton>
					</div>
				)}
			</div>
			{noSafeAreaInTheApp && <div className='h-4 w-full' />}
		</>
	)
}

export default ImageFocusedLayout
